/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.1436 8.1649c0-.564.4573-1.0213 1.0213-1.0213h8.1702c.564 0 1.0213.4573 1.0213 1.0213v8.1702c0 .564-.4573 1.0213-1.0213 1.0213H8.1649c-.564 0-1.0213-.4573-1.0213-1.0213V8.1649Zm8.6809 7.6596h-7.149v-7.149h7.149v7.149Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.5691 23.484a.766.766 0 0 0 1.532 0v-2.0425h2.2978c1.1281 0 2.0426-.9145 2.0426-2.0426v-2.2978h2.0425a.766.766 0 0 0 0-1.532h-2.0425V13.016h2.0425a.766.766 0 0 0 0-1.532h-2.0425V8.9308h2.0425a.766.766 0 1 0 0-1.5319h-2.0425V5.1011c0-1.1281-.9145-2.0426-2.0426-2.0426h-2.2978V1.016a.766.766 0 0 0-1.532 0v2.0425H13.016V1.016a.766.766 0 0 0-1.532 0v2.0425H8.9308V1.016a.766.766 0 1 0-1.5319 0v2.0425H5.1011c-1.1281 0-2.0426.9145-2.0426 2.0426v2.2978H1.016a.766.766 0 1 0 0 1.532h2.0425v2.5531H1.016a.766.766 0 0 0 0 1.532h2.0425v2.5531H1.016a.766.766 0 0 0 0 1.532h2.0425v2.2978c0 1.1281.9145 2.0426 2.0426 2.0426h2.2978v2.0425a.766.766 0 1 0 1.532 0v-2.0425h2.5531v2.0425a.766.766 0 0 0 1.532 0v-2.0425h2.5531v2.0425Zm3.8298-3.5744a.5106.5106 0 0 0 .5107-.5107V5.1011a.5106.5106 0 0 0-.5107-.5107H5.1011a.5106.5106 0 0 0-.5107.5107v14.2978c0 .2821.2287.5107.5107.5107h14.2978Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'CPU'
);
